import styled from 'styled-components';
import { Link } from 'react-router-dom';
import color from '../../constants/color';
import materialUI from '../../material-UI';

export const ContainerRow = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
`;
export const Row = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;
export const Span = styled.div`
  color: ${color.darkgrey};
  font-size: 13px;
  text-decoration: none;
  margin-top: 2px;
`;
export const Img: any = styled.img`
  height: 20px;
`;
export const OnPress = styled(materialUI.IconButton)`
  width: 16px;
  height: 16px;
  margin-right: 6px;
`;
export const DropDown = styled(materialUI.Card)`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 15px;
`;
export const Nav = styled(materialUI.Breadcrumbs)``;
export const Route = styled(Link)`
  color: ${color.darkgrey};
  font-size: 13px;
  text-decoration: none;
`;
export const Card = styled(materialUI.Card)`
  margin-top: 64px;
`;
